/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.ads
 */
AdService.$inject = [
    'AppNexusService',
    'NativeAdsService',
    'GoogleAdService',
];
function AdService(
    AppNexusService,
    NativeAdsService,
    GoogleAdService
) {
    return {
        adsEnabled: (
            AppNexusService.isEnabled ||
            NativeAdsService.isEnabled ||
            GoogleAdService.isEnabled
        ),
    };
}

module.exports = AdService;